// TODO:: Update error message mapping to remove eslint complexity issue
/* eslint-disable complexity */
import i18n from '@webtrader/core/i18n';

export enum EHttpResponseCode {
  ENTITY_TOO_LARGE = 413
}

export enum ECommonResponseCode {
  // network response
  OK = '200',
  BAD_REQUEST = '400',
  UNAUTHORIZED = '401',
  FORBIDDEN = '403',
  SERVER_ERROR = '500',

  S2T_0000 = 'S2T_0000',
  S2T_1000 = 'S2T_1000',
  S2T_1001 = 'S2T_1001',
  S2T_1002 = 'S2T_1002',
  S2T_1003 = 'S2T_1003',
  S2T_1004 = 'S2T_1004',
  S2T_1005 = 'S2T_1005',
  S2T_1006 = 'S2T_1006',
  S2T_1007 = 'S2T_1007',
  S2T_1008 = 'S2T_1008',
  S2T_1009 = 'S2T_1009',
  S2T_1010 = 'S2T_1010',
  S2T_1011 = 'S2T_1011',
  S2T_1012 = 'S2T_1012',
  S2T_1013 = 'S2T_1013',
  S2T_1014 = 'S2T_1014',
  S2T_1015 = 'S2T_1015',

  A_1000 = 'A_1000',
  A_1001 = 'A_1001',
  A_1002 = 'A_1002',
  A_1003 = 'A_1003',
  A_1004 = 'A_1004',
  A_1005 = 'A_1005',
  A_1006 = 'A_1006',
  A_1007 = 'A_1007',
  A_1008 = 'A_1008',
  A_1009 = 'A_1009',
  A_1010 = 'A_1010',
  A_1013 = 'A_1013',
  A_1014 = 'A_1014',
  A_1015 = 'A_1015',
  A_1016 = 'A_1016',
  A_1017 = 'A_1017',
  A_1018 = 'A_1018',
  A_1019 = 'A_1019',
  A_1020 = 'A_1020',
  A_1021 = 'A_1021',
  A_1022 = 'A_1022',
  A_1023 = 'A_1023',
  A_1024 = 'A_1024',
  A_1025 = 'A_1025',
  A_1026 = 'A_1026',
  A_1027 = 'A_1027',
  A_1028 = 'A_1028',
  A_1029 = 'A_1029',
  A_1030 = 'A_1030',
  A_1031 = 'A_1031',
  A_1032 = 'A_1032',
  A_1033 = 'A_1033',
  A_1034 = 'A_1034',
  A_1035 = 'A_1035',
  A_1036 = 'A_1036',
  A_1037 = 'A_1037',
  A_1038 = 'A_1038',
  A_2000 = 'A_2000',

  AQ_0000 = 'AQ_0000',
  AQ_1000 = 'AQ_1000',
  AQ_1001 = 'AQ_1001',

  AX_1001 = 'AX_1001',
  AX_1002 = 'AX_1002',
  AX_1003 = 'AX_1003',
  AX_1004 = 'AX_1004',
  AX_1005 = 'AX_1005',
  AX_1006 = 'AX_1006',
  AX_1008 = 'AX_1008',
  AX_1009 = 'AX_1009',
  AX_1010 = 'AX_1010',
  AX_1011 = 'AX_1011',

  C_MT_0001 = 'C_MT_0001',

  MT4_0000 = 'MT4_0000',
  MT4_1000 = 'MT4_1000',
  MT4_1001 = 'MT4_1001',
  MT4_1002 = 'MT4_1002',
  MT4_1003 = 'MT4_1003',
  MT4_1004 = 'MT4_1004',
  MT4_1005 = 'MT4_1005',
  MT4_1006 = 'MT4_1006',
  MT4_1007 = 'MT4_1007',
  MT4_1008 = 'MT4_1008',
  MT4_1009 = 'MT4_1009',
  MT4_1010 = 'MT4_1010',
  MT4_1011 = 'MT4_1011',
  MT4_1012 = 'MT4_1012',
  MT4_1013 = 'MT4_1013',
  MT4_1014 = 'MT4_1014',
  MT4_1015 = 'MT4_1015',
  MT4_1016 = 'MT4_1016',
  MT4_1017 = 'MT4_1017',

  // backoffice error codes
  B_1000 = 'B_1000',
  B_1001 = 'B_1001',
  B_1002 = 'B_1002',
  B_1003 = 'B_1003',
  B_1004 = 'B_1004',
  B_1005 = 'B_1005',
  B_1006 = 'B_1006',
  B_1007 = 'B_1007',
  B_1008 = 'B_1008',

  // 301 = '301', //	FILE_EMPTY
  // 302 = '302', //	FILE_SIZE_EXCEEDED
  // 303 = '303', //	FILE_TYPE_INVALID
  // root admin error codes
  R_1000 = 'R_1000',
  R_1001 = 'R_1001',

  // MT5
  MT5_0000 = 'MT5_0000',
  MT5_1000 = 'MT5_1000',
  MT5_1001 = 'MT5_1001',
  MT5_1002 = 'MT5_1002',
  MT5_10001 = '10001',
  MT5_10002 = '10002',
  MT5_10003 = '10003',
  MT5_10004 = '10004',
  MT5_10005 = '10005',
  MT5_10006 = '10006',
  MT5_10007 = '10007',
  MT5_10008 = '10008',
  MT5_10009 = '10009',
  MT5_10010 = '10010',
  MT5_10011 = '10011',
  MT5_10012 = '10012',
  MT5_10013 = '10013',
  MT5_10014 = '10014',
  MT5_10015 = '10015',
  MT5_10016 = '10016',
  MT5_10017 = '10017',
  MT5_10018 = '10018',
  MT5_10019 = '10019',
  MT5_10020 = '10020',
  MT5_10021 = '10021',
  MT5_10022 = '10022',
  MT5_10023 = '10023',
  MT5_10024 = '10024',
  MT5_10025 = '10025',
  MT5_10026 = '10026',
  MT5_10027 = '10027',
  MT5_10028 = '10028',
  MT5_10029 = '10029',
  MT5_10030 = '10030',
  MT5_10031 = '10031',
  MT5_10032 = '10032',
  MT5_10033 = '10033',
  MT5_10034 = '10034',
  MT5_10035 = '10035',
  MT5_10036 = '10036',
  MT5_10037 = '10037',
  MT5_10038 = '10038',
  MT5_10039 = '10039',
  MT5_10040 = '10040',
  MT5_10041 = '10041',
  MT5_10042 = '10042',
  MT5_10043 = '10043',
  MT5_10044 = '10044',
  MT5_10045 = '10045',
  MT5_10046 = '10046',
  MT5_10047 = '10047',
  MT5_10048 = '10048',
  MT5_10049 = '10049',

  CTRD_1010 = 'CTRD_1010',

  SI_1006 = 'SI_1006',
  SI_1016 = 'SI_1016',
  SI_1007 = 'SI_1007',
  SI_1017 = 'SI_1017',

  // Tradewise
  TW_0000 = 'TW_0000',
  TW_1001 = 'TW_1001',
  TW_1002 = 'TW_1002',
  TW_1003 = 'TW_1003',
  TW_1004 = 'TW_1004',
  TW_1005 = 'TW_1005',
  TW_1006 = 'TW_1006',
  TW_1007 = 'TW_1007',
  TW_1008 = 'TW_1008',
  TW_1009 = 'TW_1009',
  TW_1010 = 'TW_1010'
}

const responseCodeToMessage: Record<ECommonResponseCode, () => string> = {
  [ECommonResponseCode.R_1000]: () => 'Duplicate tenant ID',
  [ECommonResponseCode.R_1001]: () => 'Invalid company ID',
  [ECommonResponseCode.B_1000]: () => 'General error',
  [ECommonResponseCode.B_1001]: () => 'Invalid credentials, please try again',
  [ECommonResponseCode.B_1002]: () => 'Invalid user status',
  [ECommonResponseCode.B_1003]: () => 'Role used by user',
  [ECommonResponseCode.B_1004]: () => 'Verification code expired',
  [ECommonResponseCode.B_1005]: () => 'Verification code invalid',
  [ECommonResponseCode.B_1006]: () => 'Failed to export CSV',
  [ECommonResponseCode.B_1007]: () => `Admin role's privilege cannot be edited`,
  [ECommonResponseCode.B_1008]: () => 'Symbol config refresh failed',
  [ECommonResponseCode.C_MT_0001]: () => i18n.t('Please contact your account manager for more information'),
  [ECommonResponseCode.MT4_0000]: () => i18n.t('Trading server error. Please try again later.'),
  [ECommonResponseCode.MT4_1000]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT4_1001]: () => i18n.t('Invalid order'),
  [ECommonResponseCode.MT4_1002]: () => i18n.t('Invalid Trading Account ID'),
  [ECommonResponseCode.MT4_1003]: () => i18n.t('Invalid order volume'),
  [ECommonResponseCode.MT4_1004]: () => i18n.t('Insufficient balance'),
  [ECommonResponseCode.MT4_1005]: () => i18n.t('Invalid Stop loss or Take profit'),
  [ECommonResponseCode.MT4_1006]: () => i18n.t('Invalid credentials, please try again'),
  [ECommonResponseCode.MT4_1007]: () => i18n.t('No changes made.'),
  [ECommonResponseCode.MT4_1008]: () => i18n.t('Trading for selected symbol is off quotes'),
  [ECommonResponseCode.MT4_1009]: () => i18n.t('Invalid Price submitted'),
  [ECommonResponseCode.MT4_1010]: () => i18n.t('Invalid current password'),
  [ECommonResponseCode.MT4_1011]: () => i18n.t('Invalid password combination. Please try again.'),
  [ECommonResponseCode.MT4_1012]: () => i18n.t('Invalid user group. Please contact customer support'),
  [ECommonResponseCode.MT4_1013]: () =>
    i18n.t('Trading is not allowed for this account. Please contact customer support.'),
  [ECommonResponseCode.MT4_1014]: () => i18n.t('Account is disabled. Please contact customer support.'),
  [ECommonResponseCode.MT4_1015]: () => i18n.t('Failed to submit order'),
  [ECommonResponseCode.MT4_1016]: () => i18n.t('No order has been deleted.'),
  [ECommonResponseCode.MT4_1017]: () => i18n.t('No order has been closed.'),
  [ECommonResponseCode.S2T_0000]: () => i18n.t('Server error. Please try again later.'),
  [ECommonResponseCode.S2T_1000]: () => i18n.t('General error. Please try again later.'),
  [ECommonResponseCode.S2T_1001]: () => i18n.t('Invalid credentials, please try again'),
  [ECommonResponseCode.S2T_1002]: () => i18n.t('New password and confirm password are not the same'),
  [ECommonResponseCode.S2T_1003]: () => i18n.t('Invalid current password'),
  [ECommonResponseCode.S2T_1004]: () =>
    i18n.t('Password must be 6-20 characters long, with at least 1 uppercase letter and 1 number'),
  [ECommonResponseCode.S2T_1005]: () => i18n.t('Mobile number has been registered'),
  [ECommonResponseCode.S2T_1006]: () => i18n.t('Email has been registered'),
  [ECommonResponseCode.S2T_1007]: () => i18n.t('Username has been registered'),
  [ECommonResponseCode.S2T_1008]: () => i18n.t('Please enter a password that has not been used before.'),
  [ECommonResponseCode.S2T_1009]: () => i18n.t('Email is not verified. Please verify and try again.'),
  [ECommonResponseCode.S2T_1010]: () => i18n.t('New password must be at least 6 characters long'),
  [ECommonResponseCode.S2T_1011]: () => i18n.t('Old password must be at least 6 characters long'),
  [ECommonResponseCode.S2T_1012]: () => i18n.t('Single Sign On Failed. Please try again.'),
  [ECommonResponseCode.S2T_1013]: () => i18n.t('Invalid account type. Please contact customer support'),
  [ECommonResponseCode.S2T_1014]: () => i18n.t('Password expired. Please login via CRM to update password.'),
  [ECommonResponseCode.S2T_1015]: () => i18n.t('Account locked. Please contact customer support.'),
  [ECommonResponseCode.A_1000]: () => i18n.t('Something went wrong. Please quit the application and try again.'),
  [ECommonResponseCode.A_1001]: () => i18n.t('Invalid symbol'),
  [ECommonResponseCode.A_1002]: () => i18n.t('No active trading account'),
  [ECommonResponseCode.A_1003]: () => i18n.t('Invalid demo account. Please contact customer support.'),
  [ECommonResponseCode.A_1004]: () => i18n.t('Invalid trading symbol'),
  [ECommonResponseCode.A_1005]: () => i18n.t('Invalid status, please try again later.'),
  [ECommonResponseCode.A_1006]: () => i18n.t('Invalid credentials, please try again'),
  [ECommonResponseCode.A_1007]: () => i18n.t('Invalid Cross Account'),
  [ECommonResponseCode.A_1008]: () => i18n.t('Invalid Product Code'),
  [ECommonResponseCode.A_1009]: () => i18n.t('Invalid Lot Size'),
  [ECommonResponseCode.A_1010]: () => i18n.t('No trading is allowed for investor account'),
  [ECommonResponseCode.A_1013]: () => i18n.t('Account is locked'),
  [ECommonResponseCode.A_1014]: () => i18n.t('Invalid bulk close quantity'),
  [ECommonResponseCode.A_1015]: () => i18n.t('Password validation failed'),
  [ECommonResponseCode.A_1016]: () => i18n.t('Failed to read JSON string'),
  [ECommonResponseCode.A_1017]: () => i18n.t('Linked account expired'),
  [ECommonResponseCode.A_1018]: () => i18n.t('Invalid remove account'),
  [ECommonResponseCode.A_1019]: () => i18n.t('Linked account password has changed'),
  [ECommonResponseCode.A_1020]: () => i18n.t('Account not linked'),
  [ECommonResponseCode.A_1021]: () => i18n.t('Account already linked'),
  [ECommonResponseCode.A_1022]: () => i18n.t('Demo account creation is disabled'),
  [ECommonResponseCode.A_1023]: () => i18n.t('New password cannot be the same as last 5 passwords used'),
  [ECommonResponseCode.A_1024]: () => i18n.t('Trader preference selected type is not valid for selected category'),
  [ECommonResponseCode.A_1025]: () => i18n.t('Trader preference input value is invalid'),
  [ECommonResponseCode.A_1026]: () => i18n.t('Invalid symbol for selected trader preference category'),
  [ECommonResponseCode.A_1027]: () => i18n.t('Invalid value for selected technical indicator'),
  [ECommonResponseCode.A_1028]: () => i18n.t('Fill policy is invalid'),
  [ECommonResponseCode.A_1029]: () => i18n.t('Trading of selected symbol is restricted due to market holiday'),
  [ECommonResponseCode.A_1030]: () => i18n.t('Symbol is disabled'),
  [ECommonResponseCode.A_1031]: () => i18n.t('One-Click Trading is currently disabled'),
  [ECommonResponseCode.A_1032]: () => i18n.t('Failed to export CSV'),
  [ECommonResponseCode.A_1033]: () => i18n.t('Invalid hidden column request'),
  [ECommonResponseCode.A_1034]: () => i18n.t('Invalid column preference'),
  [ECommonResponseCode.A_1035]: () => i18n.t('Dealer module disabled'),
  [ECommonResponseCode.A_1036]: () => i18n.t('Account unable to access dealer module'),
  [ECommonResponseCode.A_1037]: () => i18n.t('Invalid feature id'),
  [ECommonResponseCode.A_1038]: () => i18n.t('Invalid calendar event data range'),
  [ECommonResponseCode.A_2000]: () => i18n.t('Invalid configuration setting. Please contact customer support.'),
  [ECommonResponseCode.AQ_0000]: () => i18n.t('Server error. Please try again later'),
  [ECommonResponseCode.AQ_1000]: () => i18n.t('System General Error'),
  [ECommonResponseCode.AQ_1001]: () => i18n.t('System Invalid Login'),
  [ECommonResponseCode.OK]: () => '',
  [ECommonResponseCode.BAD_REQUEST]: () => '',
  [ECommonResponseCode.UNAUTHORIZED]: () => '',
  [ECommonResponseCode.FORBIDDEN]: () => '',
  [ECommonResponseCode.SERVER_ERROR]: () => i18n.t('Something went wrong. Please contact customer support.'),
  [ECommonResponseCode.MT5_0000]: () => i18n.t('Trading server error. Please try again later.'),
  [ECommonResponseCode.MT5_1000]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT5_1001]: () => i18n.t('No order has been deleted.'),
  [ECommonResponseCode.MT5_1002]: () => i18n.t('No order has been closed.'),
  [ECommonResponseCode.MT5_10001]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT5_10002]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT5_10003]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT5_10004]: () => i18n.t('The deviation must be smaller than the spread of the instrument.'),
  [ECommonResponseCode.MT5_10005]: () => i18n.t('Invalid price'),
  [ECommonResponseCode.MT5_10006]: () => i18n.t('Invalid order'),
  [ECommonResponseCode.MT5_10007]: () => i18n.t('Trader has cancelled the request.'),
  [ECommonResponseCode.MT5_10008]: () => i18n.t('Order placed'),
  [ECommonResponseCode.MT5_10009]: () => i18n.t('Request completed'),
  [ECommonResponseCode.MT5_10010]: () => i18n.t('Your order has been filled partially.'),
  [ECommonResponseCode.MT5_10011]: () => i18n.t('An error occurred while processing the request.'),
  [ECommonResponseCode.MT5_10012]: () => i18n.t('Error: Request cancelled due to a timeout.'),
  [ECommonResponseCode.MT5_10013]: () => i18n.t('Invalid request'),
  [ECommonResponseCode.MT5_10014]: () => i18n.t('Invalid order volume'),
  [ECommonResponseCode.MT5_10015]: () => i18n.t('Invalid Price submitted'),
  [ECommonResponseCode.MT5_10016]: () => i18n.t('Invalid Stop loss or Take profit'),
  [ECommonResponseCode.MT5_10017]: () => i18n.t('An error occurred while processing the request.'),
  [ECommonResponseCode.MT5_10018]: () => i18n.t('Market Closed'),
  [ECommonResponseCode.MT5_10019]: () => i18n.t('The request cannot be completed due to insufficient funds.'),
  [ECommonResponseCode.MT5_10020]: () => i18n.t('Price has changed. Please try again.'),
  [ECommonResponseCode.MT5_10021]: () => i18n.t('Error: No price quotes available to process the request.'),
  [ECommonResponseCode.MT5_10022]: () => i18n.t('Invalid Expiration Date. Please try again.'),
  [ECommonResponseCode.MT5_10023]: () => i18n.t("The order's status has been updated."),
  [ECommonResponseCode.MT5_10024]: () => i18n.t('Too many requests. Please try again.'),
  [ECommonResponseCode.MT5_10025]: () => i18n.t('No changes have been made to the trade request.'),
  [ECommonResponseCode.MT5_10026]: () => i18n.t('Autotrading is disabled by server.'),
  [ECommonResponseCode.MT5_10027]: () => i18n.t('Autotrading is disabled by client terminal.'),
  [ECommonResponseCode.MT5_10028]: () => i18n.t('Trade request is locked for processing.'),
  [ECommonResponseCode.MT5_10029]: () => i18n.t('Order or position is frozen'),
  [ECommonResponseCode.MT5_10030]: () => i18n.t('Invalid fill type'),
  [ECommonResponseCode.MT5_10031]: () => i18n.t('No connection exists with the trade server.'),
  [ECommonResponseCode.MT5_10032]: () => i18n.t('Operation is allowed for live accounts only.'),
  [ECommonResponseCode.MT5_10033]: () => i18n.t('Number of pending orders has reached the limit.'),
  [ECommonResponseCode.MT5_10034]: () => i18n.t('Volume of orders and positions for the symbol has reached the limit.'),
  [ECommonResponseCode.MT5_10035]: () => i18n.t('Incorrect or prohibited order type'),
  [ECommonResponseCode.MT5_10036]: () => i18n.t('Position has already been closed.'),
  [ECommonResponseCode.MT5_10037]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT5_10038]: () => i18n.t('The closing volume requested exceeds the current position volume.'),
  [ECommonResponseCode.MT5_10039]: () => i18n.t('A close order already exists.'),
  [ECommonResponseCode.MT5_10040]: () => i18n.t('The number of open positions has reached the limit.'),
  [ECommonResponseCode.MT5_10041]: () =>
    i18n.t('The pending order activation request is rejected, or the order is canceled.'),
  [ECommonResponseCode.MT5_10042]: () => i18n.t('Only long positions are allowed.'),
  [ECommonResponseCode.MT5_10043]: () => i18n.t('Only short positions are allowed.'),
  [ECommonResponseCode.MT5_10044]: () => i18n.t('Only closing position is allowed.'),
  [ECommonResponseCode.MT5_10045]: () => i18n.t('Only First-In, First-Out rule is allowed for closing positions.'),
  [ECommonResponseCode.MT5_10046]: () => i18n.t('Trading opposing positions on a single symbol is not permitted.'),
  [ECommonResponseCode.MT5_10047]: () => i18n.t('Order has been deleted.'),
  [ECommonResponseCode.MT5_10048]: () =>
    i18n.t('Trading is not allowed for this account. Please contact customer support.'),
  [ECommonResponseCode.MT5_10049]: () =>
    i18n.t('Trading is not allowed for this account. Please contact customer support.'),
  [ECommonResponseCode.AX_1001]: () => i18n.t('Email address not found in our system.'),
  [ECommonResponseCode.AX_1002]: () =>
    i18n.t('An account already exists with this email address. Please log in with your existing account.'),
  [ECommonResponseCode.AX_1003]: () => i18n.t('Error creating demo account. Please try again later.'),
  [ECommonResponseCode.AX_1004]: () => i18n.t('Experience feature not supported'),
  [ECommonResponseCode.AX_1005]: () =>
    i18n.t('Your demo account is expired. Please kindly reach out to us at info@aquariux.com for assistance.'),
  [ECommonResponseCode.AX_1006]: () => i18n.t('Error resetting password. Please try again later.'),
  [ECommonResponseCode.AX_1008]: () =>
    i18n.t(
      'Your demo account has met the maximum time of extension, please refer to your latest reset password to login, or contact us at info@aquariux.com for assistance.'
    ),
  [ECommonResponseCode.AX_1009]: () =>
    i18n.t(
      'We couldn’t verify your account details. Please contact us at info@aquariux.com or reset your password below using your registered email address.'
    ),
  [ECommonResponseCode.AX_1010]: () => '', // Not meant to display any error message
  [ECommonResponseCode.AX_1011]: () =>
    i18n.t('Your account is expired, please contact info@aquariux.com for a live walk through.'),
  [ECommonResponseCode.CTRD_1010]: () => i18n.t('Email is being used by another account'),
  [ECommonResponseCode.SI_1006]: () => i18n.t('Email already in use.'),
  [ECommonResponseCode.SI_1007]: () => i18n.t('Email already in use.'),
  [ECommonResponseCode.SI_1016]: () => i18n.t('An OTP was recently sent to you. Please try again after 5 minutes.'),
  [ECommonResponseCode.SI_1017]: () => i18n.t('Invalid OTP'),
  [ECommonResponseCode.TW_0000]: () => i18n.t('Server Error'),
  [ECommonResponseCode.TW_1001]: () => i18n.t('General Error'),
  [ECommonResponseCode.TW_1002]: () => i18n.t('Invalid Login'),
  [ECommonResponseCode.TW_1003]: () => i18n.t('Registration Error'),
  [ECommonResponseCode.TW_1004]: () => i18n.t('Invalid Send Code Type'),
  [ECommonResponseCode.TW_1005]: () => i18n.t('Incorrect verification code'),
  [ECommonResponseCode.TW_1006]: () => i18n.t('Session Timeout'),
  [ECommonResponseCode.TW_1007]: () => i18n.t('Account Locked'),
  [ECommonResponseCode.TW_1008]: () => i18n.t('Unauthorised'),
  [ECommonResponseCode.TW_1009]: () => i18n.t('Invalid Phone Number'),
  [ECommonResponseCode.TW_1010]: () => i18n.t('An OTP was recently sent to you. Please try again after 1 minute.')
};

export const mapResponseCodeToMessage = (code: ECommonResponseCode, fallback?: string): string => {
  return responseCodeToMessage[code]?.() || fallback || i18n.t('Unexpected error');
};
